import type { WithMultipleStyleOverrides, WithTheme } from '@opallabs/lapidary'
import type { TabProps } from '../Tab'

export const enum TabDirection {
  Column,
  Row,
}

export const enum TabLabelPosition {
  End,
  Start,
}

export const enum TabSize {
  Regular,
  Small,
}

export type TabItem = Pick<
  TabProps,
  'controlsHtmlId' | 'disabled' | 'icon' | 'label' | 'value'
>

export type TabValue = string

export type TabsProps = Readonly<
  WithMultipleStyleOverrides<'container' | 'tab'> &
    WithTheme & {
      defaultValue?: TabValue
      /**
       * Whether to display tabs in a column (`Column`) or in a row (`Row`).
       *
       * @default TabDirection.Row
       */
      direction?: TabDirection
      disabled?: boolean
      displayLabel?: boolean
      htmlId?: string
      /**
       * Invisible label applied to the tab set, used by assistive technology like
       * screenreaders.
       */
      label?: string
      labelPosition?: TabLabelPosition
      onChange(value: TabValue): void
      size?: TabSize
      tabList: TabItem[]
    }
>

export type StyleProps = Required<Pick<TabsProps, 'theme'>> &
  Pick<TabsProps, 'direction' | 'disabled'>
